import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string[];
  image?: string;
  url?: string;
  type?: string;
  structuredData?: object | object[];
  meta?: Array<{ name: string; content: string }>;
}

export const SEO = ({
  title,
  description,
  keywords = [],
  image = "/og-image.png",
  url,
  type = "website",
  structuredData,
  meta = [],
}: SEOProps) => {
  const siteTitle = "FanJago";
  const fullTitle = `${title} | ${siteTitle}`;
  const currentUrl =
    url || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}
      {meta.map((m, i) => (
        <meta key={i} name={m.name} content={m.content} />
      ))}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
